// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"93":"d84b3afd","821":"d84b3afd"}[chunkId] + ".chunk.css";
};